import { isEqual } from 'lodash'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { IOpportunityLastSelectedState } from '~/types/opportunity/models'
import type { TEntityId } from '~/types/models'

const opportunityLastSelectedStateListData =
  undefined as unknown as IOpportunityLastSelectedState[]

export const getOpportunityLastSelectedStateListData =
  getListDataFunctionFactory<IOpportunityLastSelectedState[]>({
    listData: opportunityLastSelectedStateListData,
    storageKey: 'opportunitylastselectedstates',
    getStartingListData: getStartingOpportunityLastSelectedStateListData,
  })

export async function getOpportunityLastSelectedStateData(
  id: TEntityId
): Promise<IOpportunityLastSelectedState> {
  const list: IOpportunityLastSelectedState[] =
    await getOpportunityLastSelectedStateListData()
  if (!list) {
    throw new Error(
      `getOpportunityLastSelectedStateList returned undefined/null`
    )
  }
  const opportunityLastSelectedState = list.find((olsd) => olsd.id === id)
  if (!opportunityLastSelectedState) {
    throw new Error(`Can't find opportunityLastSelectedState '${id}'`)
  }
  return opportunityLastSelectedState
}

export async function getOpportunityLastSelectedStateDataByOpportunityId(
  id: TEntityId
): Promise<IOpportunityLastSelectedState | undefined> {
  const list: IOpportunityLastSelectedState[] =
    await getOpportunityLastSelectedStateListData()
  if (!list) {
    throw new Error(
      `getOpportunityLastSelectedStateList returned undefined/null`
    )
  }
  const opportunityLastSelectedState = list.find((olsd) =>
    isEqual(olsd.opportunityId, id)
  )
  return opportunityLastSelectedState
}

export async function getStartingOpportunityLastSelectedStateListData(): Promise<
  IOpportunityLastSelectedState[]
> {
  return [
    {
      id: 'XXOLSD0001',
      hrid: 'OLSD0001',
      opportunityId: 'XXO0003',
      selectedMSId: 'XXOMS0005',
      selectedScreenTopTabValue: 'Sales',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOLSD0002',
      hrid: 'OLSD0002',
      opportunityId: 'XXO0005',
      selectedMSId: 'XXOMS0006',
      selectedScreenTopTabValue: 'Sales',
      version: '1',
      canBeDeleted: true,
    },
  ]
}
